import { useEffect, useState, useContext, useRef } from "react";
import { createBrowserRouter, RouterProvider, useNavigate } from "react-router";
import axios from 'axios';

import { AppContext } from '../../../../../context.js';

import Helmet from "../../../../components/helmet.js";
import { FilePlus, UserPlus, Edit } from "../../../../../files/icons/index.js";

function ContactTemplates() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [templates, setTemplates] = useState(null);

  useEffect(() => {
    let u = context.addSpiner();
    axios.get('/api/admin/settings').then((response) => {
      setTemplates(response.data.contactTemplates);
      setLoading(false);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, []);

  function renderTemplates() {
    if (!templates || templates.length === 0) {
      return (
        <div className="d-flex justify-content-center align-items-center mt-4">
          <div className="typo-normal-150 text-muted">No templates</div>
        </div>
      );
    }

    return templates.map((template, i) => {
      return (
        <div key={template.id} className="card clickable mb-2" onClick={() => navigate(`/settings/templates/contacts/edit/${template.id}`)}>
          <div className="card-header sm">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-strong-200">{template.title}</div>
                <div className="typo-normal-150">{template.description}</div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  if (loading) {
    return <></>;
  }

  return (
    <>
      <Helmet title="Settings | Contact Templates" />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">Patient Contact Templates</div>
                <div className="typo-normal-175">Create and manage templates for patient communications</div>
              </div>
              <div className="w-25 text-end">
                <div className="item typo-normal-150 ms-2" onClick={() => navigate('/settings/templates/contacts/create')}><UserPlus height={16} width={16} color={'grey'} /> Create Template</div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">
            {renderTemplates()}
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactTemplates;